export const isVideoTrackEnabled = (stream: MediaStream | null) => {
  return (
    stream?.getVideoTracks && (!stream?.getVideoTracks()?.length || !stream?.getVideoTracks()?.some(tr => tr.enabled))
  );
};
